<template>
  <div>
    <RangePicker
      :value="time"
      :open="isOpen"
      :mode="['year', 'year']"
      :placeholder="['开始年', '结束年']"
      format="YYYY"
      size="large"
      @openChange="handleOpenChange"
      @panelChange="handlePanelChange"
      @change="handleChange"
    />
  </div>
</template>
<script setup lang="ts">
import { DatePicker } from 'ant-design-vue'
import { ref, watch } from 'vue'
const RangePicker = DatePicker.RangePicker

const props = defineProps<{
  value?: string[]
}>()
const emit = defineEmits(['input'])
const time = ref()
const isOpen = ref(false)

watch(time, (val) => {
  if (Array.isArray(val) && val.length && val[0].format) {
    emit(
      'input',
      val.map((i) => i.format('YYYY'))
    )
  }
})

function handleOpenChange(status: boolean) {
  isOpen.value = status
}

function handlePanelChange(v: string) {
  time.value = v
  isOpen.value = false
}

function handleChange(v: string) {
  time.value = v
}
</script>
<style lang="less" scoped></style>
